import React from 'react'
import { DeviceSelectionProps } from '../../lib/type'
import DeviceTile from '@corratech/pylot-custom-kit-flow/src/Components/DeviceSelection/DeviceTile'
import { Subtotal } from '@corratech/pylot-custom-kit-flow/src/Components/Subtotal/Subtotal'
import { Button } from '@corratech/pylot-ui'
import { useTranslation } from 'next-i18next'
import cn from 'classnames'
import ds from '@corratech/pylot-custom-kit-flow/src/Components/DeviceSelection/DeviceTile.module.scss'
import { BundleItem, Maybe } from '@pylot-data/fwrdschema'

export const DeviceSelection = ({
    product,
    setStep,
    step,
    selectedOptions,
    setSelectedOptions,
    addOns,
    addProductHandler,
    isAddToCartInProgress,
    isFlavourExist,
    isStarterKit
}: DeviceSelectionProps): JSX.Element => {
    const { t } = useTranslation(['common', 'plp', 'pdp'])
    const devices = product?.items?.filter(
        (item) => item?.ooka_product_option == 'device'
    )
    const selectedDevices = devices
        ?.map((device) => {
            return device?.options?.find((option) =>
                selectedOptions?.includes(String(option?.uid))
            )
        })
        .filter((device) => device)
    const requiredDevices =
        devices?.filter((device) => {
            if (device?.required) {
                return true
            }
        }) ?? []
    const accessories = product?.items?.filter(
        (item) => item?.ooka_product_option == 'accessories'
    )

    const selectedRequiredDevice =
        devices?.filter((device) => {
            if (
                device?.required &&
                device?.options?.find((option) =>
                    selectedOptions?.includes(option?.uid!)
                )
            ) {
                return true
            }
        }) ?? []
    const renderType = (
        devices: Maybe<BundleItem>[] | undefined,
        isDevice = true
    ) =>
        devices?.map((device, ind: number) => {
            return (
                <div key={device?.sku}>
                    {isDevice && devices.length > 1 ? (
                        <p className={ds['device-title']}>
                            {isDevice
                                ? `${t('DEVICE')} ${ind + 1}`
                                : t(device?.title!)}
                        </p>
                    ) : (
                        ''
                    )}
                    <div
                        className={cn(
                            isDevice
                                ? ds['device-list']
                                : ds['accessories-list']
                        )}
                        key={device?.sku}
                    >
                        {device?.options?.map((option, index) => (
                            <div
                                key={option?.uid}
                                className={
                                    isDevice
                                        ? ds['device-tile']
                                        : ds['accessories-tile']
                                }
                            >
                                <DeviceTile
                                    device={device}
                                    option={option}
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                    isDevice={isDevice}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )
        })
    const buttonLabel = (): string => {
        const isUpsellExists = !!product?.upsell_products?.length
        const label = isUpsellExists || isFlavourExist
        if (label) {
            return t('CONTINUE')
        } else {
            return t(
                isAddToCartInProgress ? 'Adding product' : 'Go to Checkout'
            )
        }
    }

    const isDisabled = () => {
        if (requiredDevices.length > 0) {
            return !(requiredDevices.length <= selectedRequiredDevice.length)
        } else if (requiredDevices && requiredDevices?.length > 0) {
            return isStarterKit
                ? !selectedDevices?.length
                : selectedRequiredDevice &&
                      selectedRequiredDevice.length < requiredDevices.length
        } else if (requiredDevices.length === 0) {
            return false
        }
        return (
            !selectedDevices?.length ||
            (devices?.length &&
                selectedRequiredDevice.length < requiredDevices.length)
        )
    }

    return (
        <>
            <div className={ds['main-container']}>
                {devices && devices?.length > 0 && (
                    <div className={ds['device-list-container']}>
                        <div className={ds['tittle']}>
                            <p className={ds['build-your']}>
                                {t('SELECT YOUR COLOR')}
                            </p>
                        </div>
                        <div className={ds['device-container']}>
                            {renderType(devices)}
                        </div>
                    </div>
                )}
                {accessories && accessories?.length > 0 && (
                    <div
                        className={cn(
                            ds[
                                devices && devices?.length > 0
                                    ? 'device-list-container'
                                    : 'accessories-options'
                            ]
                        )}
                    >
                        <div className={ds['tittle']}>
                            <p
                                className={cn(
                                    ds['build-your'],
                                    ds['accessories-title']
                                )}
                            >
                                {t('YOUR KIT INCLUDES')}
                            </p>
                        </div>
                        <div className={ds['accessories-container']}>
                            {renderType(accessories, false)}
                        </div>
                    </div>
                )}
                <div className={ds['bottom-container']}>
                    <div className={ds['free-shipping']}>
                        <p>{t('FREE SHIPPING ON ALL KITS')}</p>
                    </div>
                    <div className={ds['pods-footer']}>
                        <p>
                            {t(
                                'Pods subscription is available with no commitment. Easily change, pause or cancel online, anytime.'
                            )}
                        </p>
                    </div>
                </div>
            </div>
            <div className={ds['price-container']}>
                <div className={ds['price']}>
                    <Subtotal
                        product={product}
                        selectedOptions={selectedOptions}
                        addOns={addOns}
                    />
                </div>
                <Button
                    type="button"
                    className={ds['add-to-cart-button']}
                    loading={false}
                    disabled={Boolean(isDisabled())}
                    onClick={() => {
                        if (
                            setStep &&
                            typeof step == 'number' &&
                            !isDisabled()
                        ) {
                            if (
                                product?.upsell_products?.length ||
                                isFlavourExist
                            ) {
                                setStep(step + 1)
                            } else if (addProductHandler) {
                                addProductHandler(null)
                            }
                        }
                    }}
                >
                    {buttonLabel()}
                </Button>
            </div>
        </>
    )
}
